import React, { ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
  transitionType?: 'slide' | 'fade' | 'scale' | 'none';
  duration?: number;
}

// Chỉnh sửa dòng này nếu Framer Motion chưa được cài đặt
// Uncomment nếu chưa có Framer Motion và comment ba dòng trên
// import React, { ReactNode } from 'react';
// import { cn } from '@/lib/utils';

export const PageTransition: React.FC<PageTransitionProps> = ({
  children,
  className,
  transitionType = 'slide',
  duration = 0.3,
}) => {
  const location = useLocation();

  // Nếu không có Framer Motion, thêm code fallback dưới đây:
  // if (!motion || !AnimatePresence) {
  //   return <div className={cn("w-full", className)}>{children}</div>;
  // }

  const transitions = {
    slide: {
      initial: { x: 20, opacity: 0 },
      animate: { x: 0, opacity: 1 },
      exit: { x: -20, opacity: 0 },
    },
    fade: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
    },
    scale: {
      initial: { scale: 0.9, opacity: 0 },
      animate: { scale: 1, opacity: 1 },
      exit: { scale: 0.9, opacity: 0 },
    },
    none: {
      initial: {},
      animate: {},
      exit: {},
    },
  };

  const selectedTransition = transitions[transitionType];

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={selectedTransition.initial}
        animate={selectedTransition.animate}
        exit={selectedTransition.exit}
        transition={{ duration, ease: "easeInOut" }}
        className={cn("w-full", className)}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition; 